import errors from "../errors";
import validate from "../validate";
const { SystemError, MatchError } = errors;

function authenticateUser(email: string, password: string): Promise<string> {
    validate.email(email);
    validate.password(password);

    const payload = { email, password };

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/users/auth`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .catch((error) => {
            throw new SystemError(error.message);
        })
        .then((res) => {
            if (res.status === 200) {
                return res.json();
            }

            return res
                .json()
                .catch((error) => {
                    throw new SystemError(error.message);
                })
                .then((body) => {
                    const { error, message } = body;

                    const Constructor = errors[error as keyof typeof errors];

                    throw new Constructor(message);
                });
        })
        .then((body) => {
            const { userId } = body;
            if (!userId) throw new MatchError("User ID not returned from server");
            return userId;
        });
}

export default authenticateUser;
